/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_ElsewhereInputs */

const en_claims_elsewhere = /** @type {(inputs: Claims_ElsewhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elsewhere`)
};

const fr_claims_elsewhere = /** @type {(inputs: Claims_ElsewhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ailleurs`)
};

/**
* | output |
* | --- |
* | "Elsewhere" |
*
* @param {Claims_ElsewhereInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_elsewhere = /** @type {((inputs?: Claims_ElsewhereInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_ElsewhereInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_elsewhere(inputs)
	return fr_claims_elsewhere(inputs)
});